import { z } from 'zod';
import { entryRowSchema } from './entry';
import { dateStringSchema } from './periods';
import { amountSchema } from './units';
import { voucherIdTypeSchema } from './voucher_id';

const voucherSeriesMetadataSchema = z.object({
  numVouchers: z.number(),
});

const aggregatedAmountMetadataSchema = z.object({
  aggregatedAmount: amountSchema,
});

const voucherSchema = z.object({
  voucherId: voucherIdTypeSchema,
  date: dateStringSchema,
  text: z.string(),
  numEntries: z.number(),
  totalAmount: amountSchema,
  totalDebit: amountSchema,
  totalCredit: amountSchema,
  entries: entryRowSchema.array(),
});
const voucherArraySchema = voucherSchema.array();
type Voucher = z.infer<typeof voucherSchema>;

// Generic voucher

const customVoucherSchemas = {
  NoMetaInfo: voucherSchema,
  AggregatedAmount: voucherSchema.extend(
    z.object({
      metaInfo: aggregatedAmountMetadataSchema,
    }).shape,
  ),
};

type VoucherMetadataType = keyof typeof customVoucherSchemas;
type VoucherWithMetadata<Type extends VoucherMetadataType> = z.infer<
  (typeof customVoucherSchemas)[Type]
>;

export {
  customVoucherSchemas,
  voucherArraySchema,
  voucherSchema,
  voucherSeriesMetadataSchema,
  type Voucher,
  type VoucherWithMetadata,
};
